import React, { useEffect, useState } from 'react';
import Tooltip from '@/components/Tooltip';
import {
  buildPauseTooltipTitle,
  buildTerminalPauseMessage,
  isTerminalPauseActive,
} from './terminalPauseUtils';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';

/** Shared pill UI — same shape next to terminals and in the preferences legend. */
export function TerminalPausedBadgePill({
  label = 'Paused',
  legend = false,
}) {
  return (
    <span
      className={`terminal-paused-badge${
        legend ? ' terminal-paused-badge--legend' : ''
      }`}
      role="status">
      <span className="terminal-paused-badge-icon" aria-hidden>
        <ReactSVG className="circlePauseIcon" src={Icons.circlePause} />
      </span>
      {label}
    </span>
  );
}

function usePauseCountdown(timeout) {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!isTerminalPauseActive(timeout)) return undefined;
    const id = window.setInterval(() => tick((n) => n + 1), 60_000);
    return () => window.clearInterval(id);
  }, [timeout]);
}

export function TerminalPausedDetailLine({ entry, terminalKey, row = false }) {
  const timeout = entry?.timeout;
  usePauseCountdown(timeout);

  if (!isTerminalPauseActive(timeout)) return null;

  const message = buildTerminalPauseMessage(entry, terminalKey);

  return (
    <p
      className={
        row
          ? 'terminal-paused-detail terminal-paused-detail-row'
          : 'terminal-paused-detail'
      }>
      {message}
    </p>
  );
}

const TerminalPausedBadge = ({
  terminalKey,
  entry,
  tooltipIdPrefix = 'terminal-pause',
  compact = false,
}) => {
  const timeout = entry?.timeout;
  usePauseCountdown(timeout);

  if (!isTerminalPauseActive(timeout)) return null;

  const tooltipId = `${tooltipIdPrefix}-${terminalKey}`;

  const badge = (
    <Tooltip
      tooltipId={tooltipId}
      title={buildPauseTooltipTitle(entry, terminalKey)}
      position="top"
      arrow
      className="terminal-paused-tooltip-trigger">
      <TerminalPausedBadgePill />
    </Tooltip>
  );

  if (compact) return badge;

  return (
    <div className="terminal-paused-block">
      {badge}
      <TerminalPausedDetailLine entry={entry} terminalKey={terminalKey} />
    </div>
  );
};

export default TerminalPausedBadge;
